import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import './NotFound.css';

const NotFound = () => {
  const backgroundImageUrl = `${process.env.PUBLIC_URL || ''}/images/NOSOTROS_fondo.svg`;
  const backgroundStyle = {
    backgroundImage: `url("${backgroundImageUrl}")`,
  };

  return (
    <div className="notfound-page">
      <div className="notfound-background" style={backgroundStyle}></div>
      <Header />
      <div className="page-content">
        <h1>PÁGINA INCORRECTA</h1>
        <Link to="/" className="historia-button">
          Regresar al Inicio
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
